const apiPrefix = '/api/v1/admin';

const routeMaker = (modelName) => {
  return (params, withPagination = true) => {
    if (typeof params !== 'object')
      return `${apiPrefix}/${modelName}/${params}`;

    const {
      page = 1,
      limit = 5,
      search = '',
      byId = null,
      by = 'users',
      establishmentId = null,
      sort = null,
      showSoftDeletedUsers = null,
    } = params;

    if (byId) {
      if (withPagination)
        return `${apiPrefix}/${by}/${byId}/${modelName}?establishment_id=${establishmentId}&limit=${limit}&page=${page}${
          search ? `&search=${search}` : ''
        }${sort ? `&sort=${sort}` : ''}
        ${
          showSoftDeletedUsers
            ? `&showSoftDeletedUsers=${showSoftDeletedUsers}`
            : ''
        }`;

      return `${apiPrefix}/${by}/${byId}/${modelName}${
        showSoftDeletedUsers
          ? `?showSoftDeletedUsers=${showSoftDeletedUsers}`
          : ''
      }`;
    }

    if (!withPagination) {
      return `${apiPrefix}/${modelName}${
        showSoftDeletedUsers
          ? `&showSoftDeletedUsers=${showSoftDeletedUsers}`
          : ''
      }`;
    }

    return `${apiPrefix}/${modelName}?limit=${limit}&page=${page}${
      search ? `&search=${search}` : ''
    }${sort ? `&sort=${sort}` : ''}
    ${
      showSoftDeletedUsers
        ? `&showSoftDeletedUsers=${showSoftDeletedUsers}`
        : ''
    }`;
  };
};
export const lecturers = ({
  search = '',
  classroomId = null,
  establishmentId = null,
}) =>
  `${apiPrefix}/lecturers?search=${search}&classroom_id=${classroomId}&establishment_id=${establishmentId}`;

// Leaving in the code base in case needed, I think the intention was it would fetch all users that a specific user has access to
// export const usersByParentId = (userId, page = 1, limit = 5, search = null) =>
//   `${apiPrefix}/users/${userId}/children?limit=${limit}&page=${page}${
//     search ? `&search=${search}` : ''
//   }`;

export const usersDeactivate = (userId) =>
  `${apiPrefix}/users/${userId}/deactivate`;

export const userRecover = (userId) => `${apiPrefix}/users/${userId}/recover`;

export const userAnonymise = (userId) =>
  `${apiPrefix}/users/${userId}/anonymise`;

export const classroomAnonymiseUsers = (classroomId) =>
  `${apiPrefix}/classrooms/${classroomId}/anonymise_users`;

export const establishmentAnonymiseUsers = (establishmentId) =>
  `${apiPrefix}/establishments/${establishmentId}/anonymise_users`;

export const establishments = routeMaker('establishments');

export const admins = (establishmentId) =>
  `${apiPrefix}/admins/${establishmentId}`;

export const getAdminsByEstablishmentId = (establishmentId) =>
  `${apiPrefix}/admins/own/${establishmentId}`;

export const getEstablishmentsByUserId = (userId) =>
  `${apiPrefix}/establishments/own/${userId}`;

export const adminEstablishmentCreate = (userId) =>
  `${apiPrefix}/admins/${userId}`;

export const adminEstablishmentDelete = (establishmentId, userId) =>
  `${apiPrefix}/admins/${userId}/establishment/${establishmentId}`;

export const getTenantsByEstablishmentId = (establishmentId) =>
  `${apiPrefix}/tenant/${establishmentId}`;

export const getSignupLinksByEstablishmentId = (establishmentId) =>
  `${apiPrefix}/elevated_privilege_signup/${establishmentId}`;

export const generateSignupLink = () =>
  `${apiPrefix}/elevated_privilege_signup `;

export const deleteSignupLink = (id) =>
  `${apiPrefix}/elevated_privilege_signup/${id}`;

export const search = (modelName, text, byId = null, byOwnerModelName = null) =>
  byId
    ? `${apiPrefix}/${byOwnerModelName}/${byId}/${modelName}/search?text=${text}`
    : `${apiPrefix}/${modelName}/search?search=${text}`;

export const classroom = (classroomId = null) =>
  classroomId
    ? `${apiPrefix}/classrooms/${classroomId}`
    : `${apiPrefix}/classrooms`;

export const shareClassroomLink = (secretToken) =>
  `${window.location.origin}/classes/share/${secretToken}`;

export const classroomLecturers = (classroomId) =>
  `${apiPrefix}/classrooms/${classroomId}/lecturers`;

export const classroomLecturer = (classroomId, lecturerId) =>
  `${apiPrefix}/classrooms/${classroomId}/lecturers/${lecturerId}`;

export const classrooms = routeMaker('classrooms');

export const childClassrooms = routeMaker('child_classrooms');

export const parentClassrooms = routeMaker('parent_classrooms');

export const classroomOptions = routeMaker('classroom_options');

export const students = routeMaker('students');

export const blocks = ({ by, byId, pageName }) =>
  `${apiPrefix}/${by}/${byId}/block?page_name=${pageName}`;

export const bmc = (bmcId) => `${apiPrefix}/bmcs/${bmcId}`;

export const bmcs = routeMaker('bmcs');

export const users = routeMaker('users');

export const usersDownloadReport = '/admin/users?format=xlsx';

export const user = (userId) => `${apiPrefix}/users/${userId}`;

export const establishment = (id = null) =>
  id ? `${apiPrefix}/establishments/${id}` : `${apiPrefix}/establishments`;

export const adminLecturers = routeMaker('admin_and_lecturers');

export const teamMembers = (bmcId) => `${apiPrefix}/bmcs/${bmcId}/team_members`;
